module.exports = __webpack_public_path__ + "img/57.22d71b60.jpg";